import React from 'react';

function HowToApply({ onRequestAssistance }) {
    return (
        <section className="information" id="how-to-apply">
            <div className="content">
                <h2>How to apply</h2>
                <p>
                    Applying for <span className="osap-highlight">OSAP</span> involves a detailed process that can be complex, requiring careful attention to deadlines, financial documentation, and eligibility criteria.
                </p>
                <p>You’ll need to submit an online application, provide income details, and ensure your program qualifies.</p>
                <p>Mistakes or delays can impact your funding, making the process daunting for many. Fortunately, private consultants can assist, guiding you through each step to maximize your chances of approval.</p>
                <p>
                    For expert help, <a href="#" onClick={onRequestAssistance}>request assistance</a> to simplify your application and avoid common pitfalls, ensuring you secure the financial support you need for your education.
                </p>
            </div>
        </section>
    );
}

export default HowToApply;